const animateImages = () => {
	const sections = document.querySelectorAll(".section-main-blog");

	sections.forEach((item) => {
		if (item.querySelectorAll(".observe-me").length > 0) {
			function createObserver() {
				function handleIntersect(entries, observer) {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							let css_classlist = entry.target.classList;
							css_classlist.add("is-inview");

							observer.unobserve(entry.target);

							setTimeout(() => {
								css_classlist.remove("is-inview");
								css_classlist.remove("observe-me");
							}, 1000); // Duration matches the animation duration in SCSS
						}
					});
				}

				let options = {
					root: null,
					rootMargin: "0px",
					threshold: 0.0,
				};

				let observer = new IntersectionObserver(handleIntersect, options);
				let targets = item.querySelectorAll(".observe-me");
				targets.forEach((target, index) => {
					observer.observe(target);
				});
			}

			createObserver();
		}
	});
};

const updateLoadMoreSummary = (currentPage) => {
	const countEl = document.querySelector("[data-pagination-count]");
	if (!countEl) return;

	const total = parseInt(countEl.dataset.total, 10);
	const perPage = parseInt(countEl.dataset.perPage, 10);
	if (!total || !perPage) return;

	const shown = Math.min(currentPage * perPage, total);

	const template = countEl.dataset.countTemplate;
	if (template) {
		countEl.textContent = template.replace("SHOWNPLACEHOLDER", shown);
	}

	/* #226 round 2 - the page-number row underlines the page the grid has been
	   loaded up to (the same cursor the count reads), so after "Load More" the
	   marker steps from 1 to 2, 3 ... Numbers stay real links to their page. */
	const pages = document.querySelector("[data-pagination-pages]");
	if (pages) {
		pages.querySelectorAll("[data-pagination-page]").forEach((el) => {
			const isCurrent = parseInt(el.dataset.paginationPage, 10) === currentPage;
			el.classList.toggle("pagination-more__page--current", isCurrent);
			if (isCurrent) {
				el.setAttribute("aria-current", "page");
			} else {
				el.removeAttribute("aria-current");
			}
		});
	}
};

/* QA #226 - Load More on the PLP.
   Three behaviours layered on Madrid's append:
   1. The in-grid Callout Card tiles are placed by per-page loop index (1, 8, 16, 24),
      so every fetched page carries the same four tiles again. Appending them would
      repeat the banners every 24 products, with page 1's last tile and page 2's first
      tile a row apart. Only product cards are appended from later pages.
   2. Loaded state is remembered per PLP URL in sessionStorage (pages loaded + scroll
      offset, written on pagehide) so a PDP round trip can put the shopper back where
      they were - see restorePlpState().
   3. The hidden inputs are the single source of truth for the page cursor; the
      summary ("Showing X of Y") and the page-number row read from them via
      updateLoadMoreSummary. */

const PLP_GRID_SELECTOR = "#ProductGridContainer .load-more-grid";

const plpStateKey = () => "plp-load-more:" + location.pathname + location.search;

const rememberPlpState = () => {
	if (!document.querySelector(PLP_GRID_SELECTOR)) return;
	const pages = parseInt($("[data-current-page]").val(), 10) || 1;
	try {
		if (pages > 1) {
			sessionStorage.setItem(plpStateKey(), JSON.stringify({ pages: pages, y: window.scrollY }));
		} else {
			sessionStorage.removeItem(plpStateKey());
		}
	} catch (e) {
		/* storage unavailable - the round trip simply starts at page 1 */
	}
};

const pageUrl = (page) => $("[data-next-url]").val().replace(/page=[0-9]+/, "page=" + page);

/* Appends one fetched page's product cards to the grid. Promo tiles are skipped
   (see note 1) and the card swipers / swatches are re-initialised for the new nodes. */
const appendPage = (responseHTML) => {
	const incoming = $(responseHTML).find(".load-more-grid").children().not(".collection-product-promo-img");
	$(".load-more-grid").append(incoming);
	if (typeof colorSwatches === "function") colorSwatches();
	animateImages();
	if (typeof loadeMoreSlider_G === "function" && loadeMoreSlider_G != null) {
		loadeMoreSlider_G();
	}
	// Productive #258 - the shopper's display choices must carry onto the
	// appended page. The Model toggle drives each card's swiper to the model
	// slide, and the swipers for these cards were only just built above, so tell
	// the toolbar controls the grid grew (plp-shot-toggle re-applies; anything
	// else that keys off the grid can listen too).
	document.dispatchEvent(
		new CustomEvent("plp:products-appended", { detail: { count: incoming.length } })
	);
};

const finishPage = (button, currentPage, totalPages, nextUrlScroll) => {
	const scollData = document.querySelector(".infinite-scroll__data");
	if (scollData && currentPage != totalPages) {
		scollData.querySelector("input[data-next-url]").dataset.nextUrl = nextUrlScroll;
		scollData.querySelector("input[data-next-url]").value = nextUrlScroll;
		scollData.querySelector("input[data-current-page]").dataset.currentPage = currentPage;
		scollData.querySelector("input[data-current-page]").value = currentPage;
		checkVisibility();
	}
	if (button) {
		button.removeAttribute("disabled");
		button.removeAttribute("aria-busy");
		button.classList.remove("loading");
	}
	updateLoadMoreSummary(currentPage);
	if (button && currentPage >= totalPages) {
		button.remove();
	}
};

const loadItems = (button) => {
	const totalPages = parseInt($("[data-total-pages]").val());
	let currentPage = parseInt($("[data-current-page]").val());
	let currentPageScroll = currentPage + 1;

	currentPage = currentPage + 1;
	const nextUrl = pageUrl(currentPage);
	const nextUrlScroll = pageUrl(currentPageScroll);
	$("[data-current-page]").val(currentPage);

	button.setAttribute("disabled", "");
	button.setAttribute("aria-busy", "true");
	button.classList.add("loading");

	$.ajax({
		url: nextUrl,
		type: "GET",
		dataType: "html",
		success: function (responseHTML) {
			appendPage(responseHTML);
		},
		complete: function () {
			if (currentPage <= totalPages) {
				finishPage(button, currentPage, totalPages, nextUrlScroll);
				rememberPlpState();
			}
		},
	});
};

/* PDP round trip. A back/forward (or reload) arrival on a PLP whose session state
   says N pages were loaded re-fetches pages 2..N in order, appends them, and only
   then scrolls to the remembered offset. history.scrollRestoration is switched to
   manual for the duration so the browser does not first jump to an offset the
   one-page document cannot reach (the reported page jump), then handed back.
   A fresh navigation to the PLP (menu link, typed URL) clears the state so the
   collection starts at page 1 as expected. bfcache restores need nothing - the
   DOM comes back intact and this script does not re-run. */
const restorePlpState = () => {
	if (!document.querySelector(PLP_GRID_SELECTOR)) return;
	const button = document.querySelector(".js-load-more");
	if (!button) return;

	const nav = performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
	const navType = nav ? nav.type : "navigate";

	let state = null;
	try {
		state = JSON.parse(sessionStorage.getItem(plpStateKey()) || "null");
	} catch (e) {
		state = null;
	}

	if (navType !== "back_forward" && navType !== "reload") {
		try {
			sessionStorage.removeItem(plpStateKey());
		} catch (e) {
			/* non-fatal */
		}
		return;
	}
	if (!state || !(state.pages > 1)) return;

	const totalPages = parseInt($("[data-total-pages]").val()) || 1;
	const target = Math.min(state.pages, totalPages);
	if (target <= 1) return;

	const previousRestoration = history.scrollRestoration;
	try {
		history.scrollRestoration = "manual";
	} catch (e) {
		/* unsupported - fall through, the final scrollTo still lands */
	}

	button.setAttribute("disabled", "");
	button.setAttribute("aria-busy", "true");
	button.classList.add("loading");

	const loadSequentially = (page) => {
		if (page > target) {
			$("[data-current-page]").val(target);
			finishPage(document.querySelector(".js-load-more"), target, totalPages, pageUrl(target));
			window.requestAnimationFrame(function () {
				window.scrollTo(0, state.y || 0);
				try {
					history.scrollRestoration = previousRestoration || "auto";
				} catch (e) {
					/* non-fatal */
				}
			});
			return;
		}
		fetch(pageUrl(page), { credentials: "same-origin" })
			.then(function (response) {
				return response.ok ? response.text() : Promise.reject(response.status);
			})
			.then(function (html) {
				appendPage(html);
				loadSequentially(page + 1);
			})
			.catch(function () {
				/* Stop at what did load; the summary reflects the real cursor. */
				$("[data-current-page]").val(page - 1);
				finishPage(document.querySelector(".js-load-more"), page - 1, totalPages, pageUrl(page - 1));
				try {
					history.scrollRestoration = previousRestoration || "auto";
				} catch (e) {
					/* non-fatal */
				}
			});
	};
	loadSequentially(2);
};

const checkVisibility = () => {
	const spinnerList = document.querySelectorAll(".js-infinite-scroll");
	spinnerList.forEach((spinner) => {
		const sectionObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					loadItems(spinner);
					sectionObserver.unobserve(entry.target);
				}
			});
		});

		sectionObserver.observe(spinner);
	});
};

function loadMore() {
	document.querySelectorAll(".js-load-more").forEach((button) => {
		button.onclick = () => {
			loadItems(button);
		};
	});

	checkVisibility();
	animateImages();
}

(function () {
	loadMore();
	restorePlpState();
	/* pagehide fires for every way off the page (link, back, close) and is the
	   last chance to read scrollY; visibilitychange covers mobile Safari, which
	   does not always fire pagehide when a tab is backgrounded. */
	window.addEventListener("pagehide", rememberPlpState);
	document.addEventListener("visibilitychange", function () {
		if (document.visibilityState === "hidden") rememberPlpState();
	});
})();
